import { getConfig } from '@/config/config';
import { getAuthorizationHeader } from '@/sgwt/sgwtConnect.ts';
import { isDefined } from '@/utils/assertions';
import { v4 } from 'uuid';

export function prepareHeaders(headers: Headers): Headers {
  const authorizationHeader = getAuthorizationHeader();
  if (isDefined(authorizationHeader)) {
    headers.set('Authorization', authorizationHeader);
  }

  const urlParams = new URLSearchParams(window.location.search);
  const isCrm = urlParams.get('isCrm');
  const isDev = getConfig().environment === 'devci';

  if (isDefined(isCrm) && isDev) {
    headers.set('X-Fake-Authentication', isCrm);
  }

  headers.set('Content-Type', 'application/json');
  headers.set('Accept', 'application/json');
  headers.set('X-Correlation-ID', v4());

  return headers;
}
